var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerPriceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94782 21H20.0518C20.5728 21 20.9998 20.573 20.9998 20.052V19.948C20.9998 19.427 20.5728 19 20.0518 19H3.94782C3.42682 19 2.99982 19.427 2.99982 19.948V20.052C2.99982 20.573 3.42682 21 3.94782 21ZM12.7499 14.8361L12.7499 6.94799C12.7499 6.42699 12.3229 5.99999 11.8019 5.99999H11.6979C11.1769 5.99999 10.7499 6.42699 10.7499 6.94799L10.7499 14.8361L9.45693 13.5431C9.06593 13.1521 8.43393 13.1521 8.04293 13.5431C7.84793 13.7381 7.74993 13.9941 7.74993 14.2501C7.74993 14.5061 7.84793 14.7611 8.04293 14.9571L11.0429 17.9571C11.4339 18.3471 12.0659 18.3471 12.4569 17.9571L15.4569 14.9571C15.8479 14.5661 15.8479 13.9331 15.4569 13.5431C15.0659 13.1521 14.4339 13.1521 14.0429 13.5431L12.7499 14.8361Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerPriceIcon);
export default __webpack_public_path__ + "static/media/lower-price-icon.8de1ed55.svg";
export { ForwardRef as ReactComponent };